/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type GetTeamAuthTeamsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class GetTeamAuthTeamsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetTeamAuthTeamsResponse429ResponseBodyData;

  constructor(
    err: GetTeamAuthTeamsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetTeamAuthTeamsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type GetTeamAuthTeamsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class GetTeamAuthTeamsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetTeamAuthTeamsResponse409ResponseBodyData;

  constructor(
    err: GetTeamAuthTeamsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetTeamAuthTeamsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type GetTeamAuthTeamsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class GetTeamAuthTeamsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetTeamAuthTeamsResponse404ResponseBodyData;

  constructor(
    err: GetTeamAuthTeamsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetTeamAuthTeamsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type GetTeamAuthTeamsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class GetTeamAuthTeamsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetTeamAuthTeamsResponseResponseBodyData;

  constructor(
    err: GetTeamAuthTeamsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetTeamAuthTeamsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type GetTeamAuthTeamsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class GetTeamAuthTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetTeamAuthTeamsResponseBodyData;

  constructor(
    err: GetTeamAuthTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetTeamAuthTeamsResponseBody";
  }
}

/**
 * Bad request
 */
export type GetTeamResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class GetTeamResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: GetTeamResponseBodyData;

  constructor(
    err: GetTeamResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "GetTeamResponseBody";
  }
}

/** @internal */
export const GetTeamAuthTeamsResponse429ResponseBody$inboundSchema: z.ZodType<
  GetTeamAuthTeamsResponse429ResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetTeamAuthTeamsResponse429ResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetTeamAuthTeamsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetTeamAuthTeamsResponse429ResponseBody$outboundSchema: z.ZodType<
  GetTeamAuthTeamsResponse429ResponseBody$Outbound,
  z.ZodTypeDef,
  GetTeamAuthTeamsResponse429ResponseBody
> = z.instanceof(GetTeamAuthTeamsResponse429ResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetTeamAuthTeamsResponse409ResponseBody$inboundSchema: z.ZodType<
  GetTeamAuthTeamsResponse409ResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetTeamAuthTeamsResponse409ResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetTeamAuthTeamsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetTeamAuthTeamsResponse409ResponseBody$outboundSchema: z.ZodType<
  GetTeamAuthTeamsResponse409ResponseBody$Outbound,
  z.ZodTypeDef,
  GetTeamAuthTeamsResponse409ResponseBody
> = z.instanceof(GetTeamAuthTeamsResponse409ResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetTeamAuthTeamsResponse404ResponseBody$inboundSchema: z.ZodType<
  GetTeamAuthTeamsResponse404ResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetTeamAuthTeamsResponse404ResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetTeamAuthTeamsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetTeamAuthTeamsResponse404ResponseBody$outboundSchema: z.ZodType<
  GetTeamAuthTeamsResponse404ResponseBody$Outbound,
  z.ZodTypeDef,
  GetTeamAuthTeamsResponse404ResponseBody
> = z.instanceof(GetTeamAuthTeamsResponse404ResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetTeamAuthTeamsResponseResponseBody$inboundSchema: z.ZodType<
  GetTeamAuthTeamsResponseResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetTeamAuthTeamsResponseResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetTeamAuthTeamsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetTeamAuthTeamsResponseResponseBody$outboundSchema: z.ZodType<
  GetTeamAuthTeamsResponseResponseBody$Outbound,
  z.ZodTypeDef,
  GetTeamAuthTeamsResponseResponseBody
> = z.instanceof(GetTeamAuthTeamsResponseResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetTeamAuthTeamsResponseBody$inboundSchema: z.ZodType<
  GetTeamAuthTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetTeamAuthTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetTeamAuthTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetTeamAuthTeamsResponseBody$outboundSchema: z.ZodType<
  GetTeamAuthTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  GetTeamAuthTeamsResponseBody
> = z.instanceof(GetTeamAuthTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const GetTeamResponseBody$inboundSchema: z.ZodType<
  GetTeamResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new GetTeamResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type GetTeamResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const GetTeamResponseBody$outboundSchema: z.ZodType<
  GetTeamResponseBody$Outbound,
  z.ZodTypeDef,
  GetTeamResponseBody
> = z.instanceof(GetTeamResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
